import {Mental2SymbolStates} from "../enums/Enum";
import {Symbol} from "./Symbol";
import {gsap} from "gsap";
import TrackEntry = PIXI.spine.core.TrackEntry;
import {Sound} from "../sound/Sound";
import {Game} from "../Game";

export class XMentalSymbol extends Symbol {
    constructor(symbolName: string, initState: Mental2SymbolStates, index: number, isActive: boolean = false) {
        super(symbolName, initState, index);
    }

    clearAnimations() {
        super.clearAnimations();
    }

    public playTrigger(isHalf: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        const animTime: number = this.skeleton.data.findAnimation("198_win").duration;
        tl.add(() => {
            this.state.setAnimation(0, isHalf ? "99_win" : "198_win", false);
        });
        tl.to({}, {duration: animTime});
        return tl;
    }

    public stopLoop():void{
        this.state.clearTracks();
    }

    public playLanding(isHalf: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        const animTime: number = this.skeleton.data.findAnimation("198").duration;
        tl.add(() => {
            this.state.setAnimation(0, isHalf ? "99" : "198", false);
        });
        tl.to({}, {duration: animTime});
        return tl;
    }

    public playAnticipation(isHalf: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            this.state.setAnimation(0, isHalf ? "99_anticipation" : "198_anticipation", true);
        });
        return tl;
    }
    public playMiss(isHalf: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            this.state.setAnimation(0, isHalf ? "99_noWin_animation" : "198_noWin_animation", false).timeScale = 0.5;
        });
        return tl;
    }

    public setResizeState(animName: string): TrackEntry {
        if (animName !== "blur") {
            animName = "198";
        }
        return super.setResizeState(animName);
    }
}